module.exports = __webpack_public_path__ + "static/media/G.01de5579.svg";